import React from 'react';
import PropTypes from 'prop-types';

import {normalizeSelectOptions} from 'common/components/form/utils';
import TabBar from 'common/components/tab-bar';
import './index.scss';

export default class FormTabBar extends React.Component {
  static propTypes = {
    data: PropTypes.any,
    field: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
  };

  render() {
    const {data, field, handleChange} = this.props;
    const options = normalizeSelectOptions(field.widget.choices);

    return (
      <div className={'FormTabBar'}>
        <TabBar onChange={handleChange} options={options} value={data} />
      </div>
    );
  }
}
